export default __webpack_public_path__ + "static/media/Gallery - Clean vs Prince_01.2ae5d2aa.jpg";